/* tslint:disable */
/* eslint-disable */
/**
 * NinjaAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { BillingMethod } from './BillingMethod';
import {
    BillingMethodFromJSON,
    BillingMethodFromJSONTyped,
    BillingMethodToJSON,
} from './BillingMethod';
import type { InvoiceStatus } from './InvoiceStatus';
import {
    InvoiceStatusFromJSON,
    InvoiceStatusFromJSONTyped,
    InvoiceStatusToJSON,
} from './InvoiceStatus';

/**
 * 
 * @export
 * @interface StaffInvoiceSchema
 */
export interface StaffInvoiceSchema {
    /**
     * 
     * @type {number}
     * @memberof StaffInvoiceSchema
     */
    id: number;
    /**
     * 
     * @type {number}
     * @memberof StaffInvoiceSchema
     */
    organizationId?: number;
    /**
     * 
     * @type {string}
     * @memberof StaffInvoiceSchema
     */
    organizationName?: string;
    /**
     * 
     * @type {number}
     * @memberof StaffInvoiceSchema
     */
    subscriptionId?: number;
    /**
     * 
     * @type {Date}
     * @memberof StaffInvoiceSchema
     */
    periodStart?: Date;
    /**
     * 
     * @type {Date}
     * @memberof StaffInvoiceSchema
     */
    periodEnd?: Date;
    /**
     * 
     * @type {InvoiceStatus}
     * @memberof StaffInvoiceSchema
     */
    status: InvoiceStatus;
    /**
     * 
     * @type {number}
     * @memberof StaffInvoiceSchema
     */
    total: number;
    /**
     * 
     * @type {number}
     * @memberof StaffInvoiceSchema
     */
    amountPaid: number;
    /**
     * 
     * @type {boolean}
     * @memberof StaffInvoiceSchema
     */
    paid: boolean;
    /**
     * 
     * @type {BillingMethod}
     * @memberof StaffInvoiceSchema
     */
    billingMethod: BillingMethod;
    /**
     * 
     * @type {Date}
     * @memberof StaffInvoiceSchema
     */
    created: Date;
}

/**
 * Check if a given object implements the StaffInvoiceSchema interface.
 */
export function instanceOfStaffInvoiceSchema(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "status" in value;
    isInstance = isInstance && "total" in value;
    isInstance = isInstance && "amountPaid" in value;
    isInstance = isInstance && "paid" in value;
    isInstance = isInstance && "billingMethod" in value;
    isInstance = isInstance && "created" in value;

    return isInstance;
}

export function StaffInvoiceSchemaFromJSON(json: any): StaffInvoiceSchema {
    return StaffInvoiceSchemaFromJSONTyped(json, false);
}

export function StaffInvoiceSchemaFromJSONTyped(json: any, ignoreDiscriminator: boolean): StaffInvoiceSchema {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'organizationId': !exists(json, 'organization_id') ? undefined : json['organization_id'],
        'organizationName': !exists(json, 'organization_name') ? undefined : json['organization_name'],
        'subscriptionId': !exists(json, 'subscription_id') ? undefined : json['subscription_id'],
        'periodStart': !exists(json, 'period_start') ? undefined : (new Date(json['period_start'])),
        'periodEnd': !exists(json, 'period_end') ? undefined : (new Date(json['period_end'])),
        'status': InvoiceStatusFromJSON(json['status']),
        'total': json['total'],
        'amountPaid': json['amount_paid'],
        'paid': json['paid'],
        'billingMethod': BillingMethodFromJSON(json['billing_method']),
        'created': (new Date(json['created'])),
    };
}

export function StaffInvoiceSchemaToJSON(value?: StaffInvoiceSchema | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'organization_id': value.organizationId,
        'organization_name': value.organizationName,
        'subscription_id': value.subscriptionId,
        'period_start': value.periodStart === undefined ? undefined : (value.periodStart.toISOString()),
        'period_end': value.periodEnd === undefined ? undefined : (value.periodEnd.toISOString()),
        'status': InvoiceStatusToJSON(value.status),
        'total': value.total,
        'amount_paid': value.amountPaid,
        'paid': value.paid,
        'billing_method': BillingMethodToJSON(value.billingMethod),
        'created': (value.created.toISOString()),
    };
}

